import { render } from "./Case.vue?vue&type=template&id=366eb90b&ts=true"
import script from "./Case.vue?vue&type=script&lang=ts"
export * from "./Case.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__